<template>
  <div id="settingsProfile">
  

    <!-- PROFILE -->
    <div class="name">Profile</div>
    <div class="settings-content">

      <div class="text-field">
        <v-text-field
          ref="inputFirstName"
          prepend-icon="mdi-account"
          label="First Name"
          v-model="user.firstName"
          :rules="rules.firstName"
          :validate-on-blur="$refs.inputFirstName && $refs.inputFirstName.valid"
        ></v-text-field>
      </div>

      <div class="text-field">
        <v-text-field
          ref="inputLastName"
          prepend-icon="account-user"
          label="Last Name"
          v-model="user.lastName"
          :rules="rules.lastName"
          :validate-on-blur="$refs.inputLastName && $refs.inputLastName.valid"
        ></v-text-field>
      </div>

      <v-text-field
        ref="inputPhone"      
        prepend-icon="phone"
        label="Phone Number"
        v-model="user.phone"
        :rules="rules.phone"
        :validate-on-blur="$refs.inputPhone && $refs.inputPhone.valid"
      ></v-text-field>

      <v-select
        v-bind:items="colors"
        v-model="user.color"
        label="Select"
        item-text="name"
        item-value="name"
        single-line
        auto
        return-object
        prepend-icon="palette"
        hide-details
      >
        <div slot="item" slot-scope="data">
          <span class="vo-color-circle" :style="{ 'background-color': getColor(data.item) }"></span>
          <span class="vo-color-name" :style="{ 'color': getColor(data.item) }">{{ data.item.name }}</span>
        </div>
        <div slot="selection" slot-scope="data">
          <span class="vo-color-circle" :style="{ 'background-color': getColor(data.item) }"></span>
          <span class="vo-color-name" :style="{ 'color': getColor(data.item) }">{{ data.item.name }}</span>
        </div>
      </v-select>  

    </div>
    
    <div class="buttons">
      <v-btn class="button" :loading="lockout" color="primary"  flat @click="save()">Save</v-btn>
    </div>

    <div class="clear"></div>


  </div>

</template>

<script>

  export default {
    data () {
      return {
        user: {
          firstName: '',
          lastName: '',
          phone: '',
          color: {},
        },
        lockout: false,
        colors: [{ r:22, g:160, b:133, a:1, name: 'teal' },
                 { r:39, g:174, b:96, a:1, name: 'green' },
                 { r:41, g:128, b:185, a:1, name: 'blue' },
                 { r:142, g:68, b:173, a:1, name: 'purple' },
                 { r:44, g:62, b:80, a:1, name: 'black' },
                 { r:243, g:156, b:18, a:1, name: 'orange' },
                 { r:211, g:84, b:0, a:1, name: 'carrot' }, 
                 { r:192, g:57, b:43, a:1, name: 'red' }],
        rules: {
          firstName: [
            function (e) {
              return !window.regex.firstName.test(e) ? 'Please enter a first name.' : true;
            }
          ],
          lastName: [
            function (e) {
              return !window.regex.lastName.test(e) ? 'Please enter a last name.' : true;
            }
          ],
          phone: [
            function (e) {
              return !window.regex.phone.test(e) ? 'Please enter a valid phone number.' : true;
            }
          ]
        }
      }
    },

    methods: {
      getColor (color) {
        return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', 1)';
      },

      save () {
        this.lockout = true;
        var valid = this.validate();

        if (!valid) {
          Toast.show('Please correct the highlighted errors.', 'error');
          this.lockout = false;
          return;
        }

        this.$store.dispatch('saveProfile', {
          user: this.user
        })
        .then(data => {

          Toast.show('Profile updated.', 'success');
          this.lockout = false;
        })
        .catch(e => {
          console.log(e);
          Toast.showError(e);
          this.lockout = false;
        });
      },

      validate () {
        this.$refs.inputFirstName.validate(true);
        this.$refs.inputLastName.validate(true);
        this.$refs.inputPhone.validate(true);

        return (this.$refs.inputFirstName.valid &&
                this.$refs.inputLastName.valid &&
                this.$refs.inputPhone.valid);
      }
    },

    created () {
      this.user.firstName = this.$store.getters.profile.firstName;
      this.user.lastName = this.$store.getters.profile.lastName;
      this.user.phone = this.$store.getters.profile.phone;
      this.user.color = this.$store.getters.profile.color;
    }
  }

</script>

<style lang="scss">

  @import '../css/global.scss';

  #settingsProfile {
    position: relative;  

    .text-field {
      display: block;
    }

   
  }

</style>



// WEBPACK FOOTER //
// src/components/SettingsProfile.vue